/* BLENIN "shop the video" (2026-09-27). Markup: sections/blenin-shop-video.liquid (placements top / below / product).
   Rows: one track per instance with every card (data-g="women|men", data-pa = place in All, data-pg = place in its
   gender); the tabs (All | Women | Men or Women | Men) filter it. Each tab shows its first 12 cards; the "More videos"
   card shows the next 12 (cap 24 per tab) and moves focus to the first new card; a tab change goes back to 12. Covers
   of hidden cards sit in data-src / data-srcset and load only when the card is shown. Last tab clicked is kept in
   localStorage bl_g; html[data-bl-g] (social link) wins. Arrows (desktop) and a thin progress line show when the row
   overflows. Previews (the entry's short loop, muted): every shown card that is at least 60% on screen plays (several
   at once) and pauses when it has left the screen; hidden cards load nothing. Never with Save-Data or reduced motion
   (cover + play glyph only), never while the panel is open (the visible ones resume after it closes), only after
   window load.
   Top bar: collapsed on load; the first expand adds the row from its <template> (nothing else loads before that).
   Panel: one <template> per entry, shown in a shell appended to <body>. A size button adds that exact variant with
   properties[_video] = entry handle (hidden in the cart: snippets/cart-item.liquid skips properties starting with "_").
   Closes with X, Esc, the backdrop and the browser back button (#<handle> is pushed on open). #<handle> deep links
   open the panel on load. "View product" sets sessionStorage bl_cc like the colour cards, so the product page opens
   on that colour with no size chosen. dataLayer (if present): bl_video_open, bl_video_add. */
(function () {
  'use strict';
  if (window.blShopVideo) return;
  window.blShopVideo = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var pageLoaded = document.readyState === 'complete';
  var shell = null, dlg, mediaSlot, listSlot, countEl, statusEl, statusText, bagBtn;
  var current = null, opener = null, pushed = false, noFocusReturn = false, statusTimer = null;

  function reduced() { return !!(mq && mq.matches); }
  function shown(el) { return !!(el && el.getClientRects().length); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function track(obj) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      try { window.dataLayer.push(obj); } catch (e) { /* ignore */ }
    }
  }
  function validHandle(h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(h); }
  function tplFor(h) { return validHandle(h) ? document.getElementById('bl-sv-tpl-' + h) : null; }
  function hashHandle() {
    var h = '';
    try { h = decodeURIComponent(window.location.hash.slice(1)); } catch (e) { /* ignore */ }
    return h;
  }

  /* ---------------- card videos: every card on screen plays its preview ---------------- */
  var cardVideos = [];
  var noAuto = false, playQueued = false;
  // A card starts when >= 60% of it is on screen and pauses when it has left the screen; several play at once.
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (!e.isIntersecting) {
        v._blIn = false;
        if (!v.paused) v.pause();
      } else if (e.intersectionRatio >= 0.6) {
        v._blIn = true;
        playCard(v);
      }
    });
  }, { threshold: [0, 0.6] }) : null;

  function connection() { return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null; }
  // No autoplay with reduced motion or Save-Data: every card keeps its cover + glyph.
  function computeNoAuto() {
    var c = connection();
    noAuto = reduced() || !!(c && c.saveData);
    document.documentElement.classList.toggle('bl-sv-noauto', noAuto);
    if (noAuto) pauseCards();
  }

  function cardOf(v) { return v.closest('[data-bl-sv-open]'); }
  function playCard(v) {
    if (noAuto || !pageLoaded || current || document.hidden || !v._blIn) return;
    var card = cardOf(v);
    if (card && card.hidden) return;
    if (!v.getAttribute('src') && v.getAttribute('data-src')) v.setAttribute('src', v.getAttribute('data-src'));
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused: the cover stays */ });
  }
  function playVisibleCards() { cardVideos.forEach(function (v) { playCard(v); }); }
  // Next frame (after a tab change, "More videos" or closing the panel); a panel opened in the same task wins.
  function playSoon() {
    if (playQueued) return;
    playQueued = true;
    requestAnimationFrame(function () { playQueued = false; playVisibleCards(); });
  }
  function pauseCards() { cardVideos.forEach(function (v) { if (!v.paused) v.pause(); }); }

  function initCardVideo(v) {
    if (v._blInit) return;
    v._blInit = true;
    v._blIn = !io;
    cardVideos.push(v);
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    v.addEventListener('pause', function () { v.classList.remove('is-playing'); });
    if (io) io.observe(v); else playCard(v);
  }

  /* ---------------- rows: filter tabs, 12 + "More videos" (cap 24), arrows, progress ---------------- */
  var PAGE = 12, CAP = 24;
  function trackOf(root) { return root.querySelector('[data-bl-sv-track]'); }

  // Cover of a card that was hidden on load: data-src / data-srcset -> src / srcset.
  function hydrate(card) {
    var img = card.querySelector('img[data-src]');
    if (!img) return;
    var ss = img.getAttribute('data-srcset');
    if (ss) img.setAttribute('srcset', ss);
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }
  function isProduct(root) { return root.getAttribute('data-placement') === 'product'; }
  // A card's place (1-based) in tab g, 0 = not in that tab.
  function placeIn(card, g) {
    if (g === 'all') return parseInt(card.getAttribute('data-pa'), 10) || 0;
    return card.getAttribute('data-g') === g ? (parseInt(card.getAttribute('data-pg'), 10) || 0) : 0;
  }
  function currentTab(root) {
    var t = root.querySelector('[data-bl-sv-tab][aria-selected="true"]');
    return t ? t.getAttribute('data-bl-sv-tab') : 'all';
  }
  // Show the first root._blLimit cards of the tab (12, or 24 after "More videos"); hide the rest and their previews.
  function applyView(root) {
    var g = root._blTab || currentTab(root), lim = root._blLimit || PAGE, prod = isProduct(root), n = 0;
    each(root.querySelectorAll('[data-bl-sv-open]'), function (c) {
      var p = prod ? 1 : placeIn(c, g);
      if (p > 0 && p <= CAP) n++;
      var vis = prod || (p > 0 && p <= lim);
      c.hidden = !vis;
      if (vis) hydrate(c);
      else each(c.querySelectorAll('video'), function (v) { if (!v.paused) v.pause(); });
    });
    var more = root.querySelector('[data-bl-sv-more]');
    if (more) more.hidden = prod || n <= lim;
    var t = trackOf(root);
    if (t) updateRow(t);
    playSoon();
  }
  function showMore(root) {
    var g = root._blTab || currentTab(root), first = null;
    root._blLimit = CAP;
    applyView(root);
    each(root.querySelectorAll('[data-bl-sv-open]'), function (c) {
      var p = placeIn(c, g);
      if (!first && p === PAGE + 1) first = c;
    });
    if (first) first.focus();
  }
  // Deep link: make the video's card visible (its tab, then "More videos" if it is beyond 12).
  function revealCard(root, card) {
    if (!card || !card.hidden || isProduct(root)) return;
    var g = root._blTab || currentTab(root);
    var p = placeIn(card, g);
    if (!(p > 0 && p <= CAP)) {
      g = card.getAttribute('data-g');
      selectTab(root, g, false);
      p = placeIn(card, g);
    }
    if (p > PAGE && p <= CAP) { root._blLimit = CAP; applyView(root); }
  }

  function preferredTab(root) {
    var tabs = root.querySelectorAll('[data-bl-sv-tab]');
    var ok = {};
    each(tabs, function (t) { ok[t.getAttribute('data-bl-sv-tab')] = 1; });
    var g = document.documentElement.getAttribute('data-bl-g');
    if (!ok[g]) { try { g = localStorage.getItem('bl_g'); } catch (e) { g = null; } }
    if (!ok[g]) g = root.getAttribute('data-default') || 'all';
    return ok[g] ? g : null;
  }

  function selectTab(root, g, store) {
    var tabs = root.querySelectorAll('[data-bl-sv-tab]');
    if (!tabs.length) return;
    var found = false;
    each(tabs, function (t) {
      var on = t.getAttribute('data-bl-sv-tab') === g;
      if (on) found = true;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    if (!found) return;
    var row = root.querySelector('[data-bl-sv-row]');
    if (row) row.setAttribute('aria-labelledby', root.id + '-t-' + g);
    // "Color guide" link (homepage in-page section): the article for the chosen gender, or all colour-guide articles
    var guide = root.querySelector('[data-bl-sv-guide]');
    if (guide && guide.getAttribute('data-' + g)) guide.setAttribute('href', guide.getAttribute('data-' + g));
    root._blTab = g;
    root._blLimit = PAGE;
    var t = trackOf(root);
    if (t) t.scrollLeft = 0;
    applyView(root);
    if (store) { try { localStorage.setItem('bl_g', g); } catch (e) { /* ignore */ } }
  }

  function updateRow(trackEl) {
    var row = trackEl.parentNode;
    var prev = row.querySelector('[data-bl-sv-arrow="-1"]');
    var next = row.querySelector('[data-bl-sv-arrow="1"]');
    var prog = row.querySelector('[data-bl-sv-progress]');
    var sw = trackEl.scrollWidth, cw = trackEl.clientWidth;
    var max = sw - cw;
    var over = shown(trackEl) && max > 2;
    if (prev && next) {
      prev.hidden = !over;
      next.hidden = !over;
    }
    if (prog) prog.hidden = !over;
    if (!over) return;
    var x = Math.abs(trackEl.scrollLeft);
    if (prev && next) {
      prev.disabled = x <= 2;
      next.disabled = x >= max - 2;
    }
    if (prog) {
      var f = Math.max(0.08, Math.min(1, cw / sw));
      var p = max > 0 ? Math.min(1, x / max) : 0;
      var bar = prog.firstElementChild;
      bar.style.width = (f * 100) + '%';
      bar.style.transform = 'translateX(' + (p * (1 - f) / f * 100) + '%)';
    }
  }
  function updateAllRows() { each(document.querySelectorAll('[data-bl-sv-track]'), updateRow); }

  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) { updateRow(e.target); });
  }) : null;

  function initRows(root) {
    if (root._blRows) return;
    root._blRows = true;
    each(root.querySelectorAll('.bl-sv__media video'), initCardVideo);
    each(root.querySelectorAll('[data-bl-sv-track]'), function (t) {
      var queued = false;
      t.addEventListener('scroll', function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; updateRow(t); });
      }, { passive: true });
      if (ro) ro.observe(t);
      updateRow(t);
    });
    var tabs = root.querySelectorAll('[data-bl-sv-tab]');
    each(tabs, function (t, i) {
      t.addEventListener('click', function () { selectTab(root, t.getAttribute('data-bl-sv-tab'), true); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % tabs.length;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = tabs.length - 1;
        if (j < 0) return;
        e.preventDefault();
        tabs[j].focus();
        selectTab(root, tabs[j].getAttribute('data-bl-sv-tab'), true);
      });
    });
    each(root.querySelectorAll('[data-bl-sv-arrow]'), function (b) {
      b.addEventListener('click', function () {
        var t = trackOf(root);
        if (!t) return;
        var dir = parseInt(b.getAttribute('data-bl-sv-arrow'), 10) || 1;
        var step = Math.max(t.clientWidth * 0.8, 200);
        t.scrollBy({ left: dir * step, behavior: reduced() ? 'auto' : 'smooth' });
      });
    });
    each(root.querySelectorAll('[data-bl-sv-more]'), function (b) {
      b.addEventListener('click', function () { showMore(root); });
    });
    root._blTab = currentTab(root);
    root._blLimit = PAGE;
    applyView(root);
  }

  /* ---------------- top bar: collapsed on load, expands into the row ---------------- */
  function initBar(root) {
    var bar = root.querySelector('[data-bl-sv-bar]');
    var drawer = bar && document.getElementById(bar.getAttribute('aria-controls'));
    if (!bar || !drawer) return;
    var endTimer = null;
    function done(fn) {
      clearTimeout(endTimer);
      var fired = false;
      var h = function () { if (fired) return; fired = true; drawer.removeEventListener('transitionend', h); fn(); };
      drawer.addEventListener('transitionend', h);
      endTimer = setTimeout(h, 450);
    }
    bar.addEventListener('click', function () {
      var open = bar.getAttribute('aria-expanded') !== 'true';
      if (open) {
        if (!drawer._blFilled) {
          var tpl = drawer.querySelector('template[data-bl-sv-lazy]');
          if (tpl) drawer.appendChild(tpl.content.cloneNode(true));
          drawer._blFilled = true;
          initRows(root);
          var g = preferredTab(root);
          if (g) selectTab(root, g, false);
        }
        bar.setAttribute('aria-expanded', 'true');
        drawer.hidden = false;
        if (!reduced()) {
          var target = drawer.scrollHeight;
          drawer.style.height = '0px';
          void drawer.offsetHeight;
          drawer.style.height = target + 'px';
          done(function () { if (bar.getAttribute('aria-expanded') === 'true') drawer.style.height = ''; });
        }
        each(drawer.querySelectorAll('[data-bl-sv-track]'), updateRow);
      } else {
        bar.setAttribute('aria-expanded', 'false');
        each(drawer.querySelectorAll('video'), function (v) { if (!v.paused) v.pause(); });
        if (reduced()) { drawer.hidden = true; return; }
        drawer.style.height = drawer.scrollHeight + 'px';
        void drawer.offsetHeight;
        drawer.style.height = '0px';
        done(function () {
          if (bar.getAttribute('aria-expanded') === 'false') { drawer.hidden = true; drawer.style.height = ''; }
        });
      }
    });
  }

  function initRoot(root) {
    if (root._blInit) return;
    root._blInit = true;
    if (root.querySelector('[data-bl-sv-bar]')) initBar(root);
    else initRows(root);
  }

  function findCard(h) {
    var cards = document.querySelectorAll('[data-bl-sv-open="' + h + '"]');
    for (var i = 0; i < cards.length; i++) if (shown(cards[i])) return cards[i];
    return null;
  }

  /* ---------------- panel ---------------- */
  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function buildShell() {
    shell = document.createElement('div');
    shell.className = 'bl-svp';
    shell.hidden = true;
    shell.innerHTML =
      '<div class="bl-svp__backdrop" data-bl-svp-close></div>' +
      '<div class="bl-svp__dialog" role="dialog" aria-modal="true" aria-labelledby="bl-svp-title" tabindex="-1">' +
        '<button type="button" class="bl-svp__close" data-bl-svp-close aria-label="Close">' + ICON_X + '</button>' +
        '<div class="bl-svp__media"></div>' +
        '<div class="bl-svp__side">' +
          '<div class="bl-svp__head">' +
            '<div class="bl-svp__head-row"><h2 class="bl-svp__title" id="bl-svp-title">Shop the video</h2><p class="bl-svp__count"></p></div>' +
            '<p class="bl-svp__hint">Tap a size to add it to your bag.</p>' +
          '</div>' +
          '<div class="bl-svp__list"></div>' +
          '<div class="bl-svp__foot">' +
            '<p class="bl-svp__status" role="status" aria-live="polite"><span class="bl-svp__status-text"></span> ' +
              '<button type="button" class="bl-svp__bag" hidden>View bag</button></p>' +
            '<p class="bl-svp__ship">Ships within 7 days &middot; 30-day returns</p>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(shell);
    dlg = shell.querySelector('.bl-svp__dialog');
    mediaSlot = shell.querySelector('.bl-svp__media');
    listSlot = shell.querySelector('.bl-svp__list');
    countEl = shell.querySelector('.bl-svp__count');
    statusEl = shell.querySelector('.bl-svp__status');
    statusText = shell.querySelector('.bl-svp__status-text');
    bagBtn = shell.querySelector('.bl-svp__bag');

    shell.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-bl-svp-close]')) { requestClose(); return; }
      var add = t.closest('.bl-svp__size:not([disabled]), .bl-svp__add:not([disabled])');
      if (add) { addToBag(add); return; }
      if (t.closest('[data-bl-svp-pp]')) { togglePlay(); return; }
      if (t.closest('.bl-svp__bag')) { viewBag(); }
    });
    shell.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); requestClose(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); dlg.focus(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || a === dlg || !dlg.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !dlg.contains(a))) { e.preventDefault(); first.focus(); }
    });
  }

  function focusables() {
    return Array.prototype.filter.call(
      dlg.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return shown(el) && el.getAttribute('aria-hidden') !== 'true' && el.tabIndex !== -1; }
    );
  }

  function panelVideo() { return mediaSlot ? mediaSlot.querySelector('video') : null; }

  function bestMp4(list) {
    // "url WxH,url WxH": the largest with the short side <= 720 px, else the smallest.
    var best = null, small = null;
    (list || '').split(',').forEach(function (s) {
      var p = s.trim().split(' ');
      if (!p[0]) return;
      var d = (p[1] || '').split('x'), w = parseInt(d[0], 10) || 0, h = parseInt(d[1], 10) || 0, short = Math.min(w, h) || 0;
      var o = { u: p[0], s: short, a: w * h };
      if (short && short <= 720 && (!best || short > best.s)) best = o;
      if (!small || o.a < small.a) small = o;
    });
    return (best || small || {}).u || '';
  }

  function setPP(playing) {
    var b = mediaSlot && mediaSlot.querySelector('[data-bl-svp-pp]');
    if (!b) return;
    b.classList.toggle('is-paused', !playing);
    b.setAttribute('aria-label', playing ? 'Pause the video' : 'Play the video');
  }

  function startPanelVideo() {
    var v = panelVideo();
    if (!v) return;
    var hls = v.getAttribute('data-hls');
    var src = hls && v.canPlayType('application/vnd.apple.mpegurl') ? hls : bestMp4(v.getAttribute('data-mp4'));
    if (!src) return;
    v.muted = true;
    // Never with sound (music from social posts is not licensed for the website).
    v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
    v.addEventListener('play', function () { setPP(true); });
    v.addEventListener('pause', function () { setPP(false); });
    v.setAttribute('src', src);
    if (reduced()) { setPP(false); return; }
    v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(function () { setPP(false); });
  }

  function togglePlay() {
    var v = panelVideo();
    if (!v) return;
    if (v.paused) {
      v._blUserPaused = false;
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* ignore */ });
    } else {
      v._blUserPaused = true;
      v.pause();
    }
  }

  // Browsers hold autoplay in background tabs (e.g. a #handle link opened in a new tab): start when the tab shows.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden || !current || reduced()) return;
    var v = panelVideo();
    if (v && v.paused && !v._blUserPaused && v.getAttribute('src')) {
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* ignore */ });
    }
  });

  function stopPanelVideo() {
    var v = panelVideo();
    if (!v) return;
    v.pause();
    v.removeAttribute('src');
    try { v.load(); } catch (e) { /* ignore */ }
  }

  function setStatus(text, showBag, isError) {
    clearTimeout(statusTimer);
    statusText.textContent = text || '';
    bagBtn.hidden = !showBag;
    statusEl.classList.toggle('is-error', !!isError);
    statusEl.classList.toggle('is-on', !!text);
    if (isError) statusTimer = setTimeout(function () { setStatus('', false, false); }, 5000);
  }

  function open(h, fromEl, fromHash) {
    var tpl = tplFor(h);
    if (!tpl) return false;
    if (!shell) buildShell();
    if (current) closeNow();
    var frag = tpl.content.cloneNode(true);
    mediaSlot.innerHTML = '';
    listSlot.innerHTML = '';
    var m = frag.querySelector('.bl-svp__m'), l = frag.querySelector('.bl-svp__l');
    if (m) mediaSlot.appendChild(m);
    if (l) listSlot.appendChild(l);
    countEl.textContent = tpl.getAttribute('data-n') || '';
    setStatus('', false, false);
    if (fromHash) {
      // Deep link (#handle): make sure the video's card is visible in the rows (its gender tab, "More videos").
      each(document.querySelectorAll('[data-bl-sv]'), function (r) {
        if (!r._blRows) return;
        revealCard(r, r.querySelector('[data-bl-sv-open="' + h + '"]'));
      });
    }
    current = h;
    opener = fromEl || null;
    pushed = !!(history.state && history.state.blsv === h);
    if (!fromHash && !pushed) {
      try { history.pushState({ blsv: h }, '', '#' + h); pushed = true; } catch (e) { pushed = false; }
    }
    pauseCards();
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.documentElement.classList.add('bl-svp-open');
    shell.hidden = false;
    listSlot.scrollTop = 0;
    dlg.scrollTop = 0;
    requestAnimationFrame(function () { if (current === h) shell.classList.add('is-open'); });
    dlg.focus({ preventScroll: true });
    startPanelVideo();
    track({ event: 'bl_video_open', bl_video: h, bl_gender: tpl.getAttribute('data-g') || '' });
    return true;
  }

  function closeNow() {
    if (!current) return;
    var h = current;
    stopPanelVideo();
    current = null;
    pushed = false;
    shell.classList.remove('is-open');
    shell.hidden = true;
    mediaSlot.innerHTML = '';
    listSlot.innerHTML = '';
    document.documentElement.classList.remove('bl-svp-open');
    document.body.style.paddingRight = '';
    if (!noFocusReturn) {
      var target = opener && document.contains(opener) && shown(opener) ? opener : findCard(h);
      if (target) target.focus();
    }
    noFocusReturn = false;
    opener = null;
    playSoon();
  }

  // X, Esc, backdrop: close now, then drop the #handle history entry we pushed on open (its popstate is a no-op).
  function requestClose() {
    if (!current) return;
    var h = current;
    var viaBack = pushed && history.state && history.state.blsv === h;
    closeNow();
    if (viaBack) {
      history.back();
    } else if (hashHandle() === h) {
      try { history.replaceState(history.state, '', window.location.pathname + window.location.search); } catch (e) { /* ignore */ }
    }
  }

  function viewBag() {
    var drawer = document.querySelector('.js-cart-drawer');
    var back = opener || findCard(current);
    var useDrawer = !!(drawer && typeof drawer.open === 'function');
    noFocusReturn = useDrawer;
    requestClose();
    if (useDrawer) drawer.open(back);
    else window.location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart';
  }

  // Back button closes the panel (its #handle entry was pushed on open); forward or a typed #handle opens it.
  window.addEventListener('popstate', function () {
    var h = hashHandle();
    if (current === h) return;
    if (current) { pushed = false; closeNow(); }
    if (tplFor(h)) open(h, null, true);
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && current) {
      var v = panelVideo();
      if (v && v.paused && !reduced()) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
  });

  /* ---------------- add to bag ---------------- */
  function sectionsToUpdate() {
    return ['page-header', 'cart-drawer'].map(function (s) { return document.querySelector(s); })
      .filter(function (el) { return el && el.dataset && el.dataset.sectionId; });
  }

  function addToBag(btn) {
    if (btn.classList.contains('is-loading') || !current) return;
    var id = btn.getAttribute('data-id');
    if (!id) return;
    var h = current;
    var item = btn.closest('.bl-svp__item');
    var name = item && item.querySelector('.bl-svp__name') ? item.querySelector('.bl-svp__name').textContent : '';
    var size = btn.getAttribute('data-size') || '';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    setStatus('', false, false);
    var els = sectionsToUpdate();
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    fd.append('properties[_video]', h);
    fd.append('sections_url', window.location.pathname);
    fd.append('sections', els.map(function (el) { return el.dataset.sectionId; }).join(','));
    var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    fetch(url, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        var data = res.data || {};
        if (!res.ok || data.status) {
          throw new Error(typeof data.description === 'string' ? data.description : (data.message || 'Could not add to bag. Please try again.'));
        }
        if (document.querySelector('.template-cart')) { window.location.reload(); return; }
        els.forEach(function (el) {
          if (data.sections && data.sections[el.dataset.sectionId] && typeof el.updateFromCartChange === 'function') {
            el.updateFromCartChange(data.sections[el.dataset.sectionId]);
          }
        });
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        if (current === h) setStatus('Added to bag: ' + name + (size ? ', ' + size : '') + '.', true, false);
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: data.variant_id || data.id } }));
        track({ event: 'bl_video_add', bl_video: h, variant_id: String(data.variant_id || id) });
      })
      .catch(function (err) {
        if (current === h) setStatus(err && err.message ? err.message : 'Could not add to bag. Please try again.', false, true);
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  }

  /* ---------------- global listeners ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('[data-bl-sv-open]');
    if (card) { e.preventDefault(); open(card.getAttribute('data-bl-sv-open'), card, false); }
  });

  // "View product": the product page opens on this colour with no size chosen (sections/main-product.liquid reads bl_cc).
  function rememberColour(e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-bl-cc]');
    if (!a) return;
    try { sessionStorage.setItem('bl_cc', JSON.stringify({ v: a.getAttribute('data-bl-cc'), t: Date.now() })); } catch (err) { /* ignore */ }
  }
  document.addEventListener('click', rememberColour, true);
  document.addEventListener('auxclick', rememberColour, true);

  if (mq) {
    var onMq = function () {
      computeNoAuto();
      if (!reduced()) { playVisibleCards(); return; }
      pauseCards();
      var pv = panelVideo();
      if (pv) pv.pause();
    };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }
  var conn = connection();
  if (conn && conn.addEventListener) conn.addEventListener('change', function () { computeNoAuto(); playVisibleCards(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) pauseCards(); else playVisibleCards(); });
  computeNoAuto();

  if (!ro) {
    var resizeQueued = false;
    window.addEventListener('resize', function () {
      if (resizeQueued) return;
      resizeQueued = true;
      requestAnimationFrame(function () { resizeQueued = false; updateAllRows(); });
    });
  }

  window.addEventListener('load', function () {
    pageLoaded = true;
    updateAllRows();
    playVisibleCards();
  });

  document.addEventListener('shopify:section:load', function (e) {
    each(e.target.querySelectorAll('[data-bl-sv]'), initRoot);
  });

  function init() {
    each(document.querySelectorAll('[data-bl-sv]'), initRoot);
    var h = hashHandle();
    if (tplFor(h)) open(h, null, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
